import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-streak',
  templateUrl: './streak.component.html',
  styleUrls: ['./streak.component.scss'],
  standalone: false
})
export class StreakComponent {

  @Input() streakNumber?: number;
  @Input() days: any = [];

  constructor() {}

  ngOnInit() {}
}
